import { DemoAlarmIngestResponse } from '@hakimo-ui/hakimo/types';

interface IngestResponseDTO {
  payload: {
    errors?: { alarm_id: string; error: string }[];
  };
}

export async function parseIngestResponse(
  response: Response
): Promise<DemoAlarmIngestResponse> {
  const json = (await response.json()) as IngestResponseDTO;
  return {
    errors: json.payload.errors?.map((e) => ({
      alarmId: e.alarm_id,
      error: e.error,
    })),
  };
}
